/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, ActivityIndicator } from 'react-native';
import { CONTENT_MAX_WIDTH_AUTH } from '../../shared/layout/breakpoints';
import { AuthScreenFrame } from '../../shell/brand/AuthScreenFrame';
import { AppLogoMark } from '../../shell/brand/AppLogoMark';
import { AUTH_ACCENT_INK, authFormUi } from './components/authFormUi';
import { logout } from '../application/authSession';

type Props = {
  onRetry: () => void;
  retrying?: boolean;
};

/** Primer setup / bootstrap: siempre requiere conexión (web y nativo). */
export const OfflineSetupRequired = ({ onRetry, retrying }: Props) => {
  return (
    <AuthScreenFrame>
      <View style={styles.root} accessibilityLabel="Requiere conexión para configurar">
        <View style={[authFormUi.card, styles.cardMax]}>
          <View style={authFormUi.brandBlock}>
            <AppLogoMark size={56} showWordmark />
          </View>
          <View style={styles.head}>
            <Text style={authFormUi.title}>Sin internet no podemos continuar</Text>
            <Text style={authFormUi.subtitle}>
              Para armar o sincronizar tu cuenta hace falta conexión. Probá de nuevo cuando vuelva
              la señal.
            </Text>
          </View>
          <TouchableOpacity
            style={[authFormUi.primaryBtn, retrying && authFormUi.primaryBtnDisabled]}
            onPress={onRetry}
            disabled={retrying}
            accessibilityRole="button"
            accessibilityLabel="Reintentar conexión"
            testID="offline-setup.retry"
          >
            {retrying ? (
              <ActivityIndicator color={AUTH_ACCENT_INK} />
            ) : (
              <Text style={authFormUi.primaryLabel}>Reintentar</Text>
            )}
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => void logout()}
            disabled={retrying}
            accessibilityRole="button"
            accessibilityLabel="Cerrar sesión"
            testID="offline-setup.logout"
          >
            <Text style={[authFormUi.linkLabelMuted, styles.center]}>Cerrar sesión</Text>
          </TouchableOpacity>
        </View>
      </View>
    </AuthScreenFrame>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  cardMax: {
    maxWidth: CONTENT_MAX_WIDTH_AUTH,
  },
  head: {
    gap: 8,
  },
  center: {
    textAlign: 'center',
  },
});
